// src/components/RentCategories.jsx

import React from "react";
import { Table, Camera, ShoppingCart } from "lucide-react";
import { motion } from "framer-motion";
import { AnimatedButton1 } from "../Effects/AnimatedButton1";
import { useNavigate } from "react-router-dom";


const rentCategories = [
  {
    title: "Tables & Chairs",
    icon: Table,
    description: " Seating and table options for dining, events, or ceremonies.",
  },
  {
    title: "Studio Equipment",
    icon: Camera,
    description: "Technical and structural gear for performances, stages, and media setups.",
  },
  {
    title: "Carts",
    icon: ShoppingCart,
    description: " Food and experience carts for events, parties, and activations.",
  },
];

export default function RentCategories() {

  const navigate = useNavigate(); 

  const handleClick = () => {
    
    navigate("/rentitems");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };


  return (
    <section className="max-w-6xl mx-auto px-4 py-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-5xl font-bebas text-center mb-12 text-black"
      >
        Explore Our Rental Categories
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {rentCategories.map(({ title, icon: Icon, description }) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl p-8 shadow hover:shadow-lg transition-all border border-gray-200"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <Icon className="w-12 h-12 text-black" />
              <h3 className="text-2xl font-bebas text-black ">{title}</h3>
              <p className="text-gray-700">{description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="flex justify-center mt-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
         <AnimatedButton1
                  text="Explore"
                  onClick={handleClick}
                />
      </motion.div>
    </section>
  );
}
